export default __webpack_public_path__ + "c63c27550b71b81836c6152b93ad4aa5.svg";